import React, { Component } from 'react';
import { render } from 'react-dom';

import Highcharts from 'highcharts';
import highchartsMore from "highcharts/highcharts-more";
import HighchartsReact from 'highcharts-react-official';

highchartsMore(Highcharts);

const options = {
//   colors: ['#FFD700', '#C0C0C0', '#CD7F32','#'],
    chart: {
        type: 'column',
        inverted: true,
        polar: true
    },
    title: {
        text: 'Quzz X Progress'
    },
    tooltip: {
        outside: true
    },
    pane: {
        size: '85%',
        innerSize: '20%',
        endAngle: 270
    },
    xAxis: {
        tickInterval: 1,
        labels: {
            align: 'right',
            useHTML: true,
            allowOverlap: false,
            step: 1,
            y: 3,
            style: {
                fontSize: '13px'
            }
        },
        lineWidth: 0,
        categories: ['Question: 1','Question: 2','Question: 3', 'Question: 4']
    },
    yAxis: {
        crosshair: {
            enabled: true,
            color: '#333'
        },
        lineWidth: 0,
        tickInterval: 25,
        reversedStacks: false,
        endOnTick: true,
        showLastLabel: true
    },
    plotOptions: {
        column: {
            stacking: 'normal',
            borderWidth: 0,
            pointPadding: 0,
            groupPadding: 0.15
        }
    },
    series: [{
        data:[20,200,230,32,333,890,2334,6367,490]
    }]
}

const SampleEx = () => <div>
  <HighchartsReact
    highcharts={Highcharts}
    options={options}
  />
</div>

export default SampleEx


